// 权限工具函数
import { useAuthStore } from '@/stores/auth'

/**
 * 检查当前用户是否有指定权限
 * admin 角色拥有所有权限
 * @param permission 权限代码，如 'sales:read'
 * @returns boolean
 */
export function hasPermission(permission: string): boolean {
  const authStore = useAuthStore()
  // 用户信息未加载时不放行，防止权限检查失效
  if (!authStore.userInfo) return false
  const roles = Array.from(authStore.userInfo?.roles || [])
  // admin 拥有所有权限
  if (roles.indexOf('admin') >= 0) return true
  const permissions = Array.from(authStore.userInfo?.permissions || [])
  return permissions.indexOf(permission) >= 0
}

/**
 * 检查当前用户是否有任意一个权限
 * @param permissions 权限代码数组
 * @returns boolean
 */
export function hasAnyPermission(permissions: string[]): boolean {
  const authStore = useAuthStore()
  const userPerms = Array.from(authStore.userInfo?.permissions || [])
  return permissions.some(p => userPerms.indexOf(p) >= 0)
}

/**
 * 检查当前用户是否拥有所有指定权限
 * @param permissions 权限代码数组
 * @returns boolean
 */
export function hasAllPermissions(permissions: string[]): boolean {
  const authStore = useAuthStore()
  const userPerms = Array.from(authStore.userInfo?.permissions || [])
  return permissions.every(p => userPerms.indexOf(p) >= 0)
}

/**
 * 检查当前用户是否有指定角色
 * @param role 角色代码，如 'admin'
 * @returns boolean
 */
export function hasRole(role: string): boolean {
  const authStore = useAuthStore()
  const roles = Array.from(authStore.userInfo?.roles || [])
  return roles.indexOf(role) >= 0
}

/**
 * 检查当前用户是否有任意一个角色
 * @param roles 角色代码数组
 * @returns boolean
 */
export function hasAnyRole(roles: string[]): boolean {
  const authStore = useAuthStore()
  const userRoles = Array.from(authStore.userInfo?.roles || [])
  return roles.some(r => userRoles.indexOf(r) >= 0)
}
